// @ts-nocheck
import { GetProductCollectionRealTimePriceApiV2Parameter } from "@insite/client-framework/Services/ProductServiceV2";
import loadRealTimePricing from "@insite/client-framework/Store/CommonHandlers/LoadRealTimePricing";
import {
    chain,
    LoadProductIfNeeded,
} from "@insite/client-framework/Store/Pages/ProductDetails/Handlers/DisplayProduct";
import tryJsonParse from "@store/Framework/Common/Utilities/tryJsonParse";
import { MultiLocationCatalogResultModel } from "@store/Framework/Types/ApiModels";
import { addToChainBefore, addToEndOfChain } from "@toolkit/Modules/client-framework/HandlerCreator";

addToChainBefore(chain, LoadProductIfNeeded, props => {
    (props as any).parameter.additionalExpands = ["documents", "properties"];
});

// Load multi-location catalog prices
addToEndOfChain(chain, props => {
    if (!props.product) {
        return;
    }

    const {
        id: productId,
        unitOfMeasures,
        properties: { multiLocationCatalogResult },
    } = props.product;

    const mlcData = tryJsonParse<MultiLocationCatalogResultModel>(multiLocationCatalogResult);
    const abort = () => {
        props.dispatch({
            type: "Greif/Pages/ProductDetails/CompleteLoadMlcData",
            productId,
            multiLocationCatalogInfo: {
                pricing: [],
                isMlcProduct: false,
                fullTruckLoads: [],
                leadTimes: [],
                availableAtOtherShipTos: {},
            },
        });
    };

    if (!mlcData || !mlcData.availableAtOtherShipTos) {
        abort();
        return;
    }

    const unitOfMeasure = unitOfMeasures?.[0]?.unitOfMeasure ?? "ea";
    const qtyOrdered = unitOfMeasures?.[0]?.qtyPerBaseUnitOfMeasure ?? 1;
    const productPriceParameters: GetProductCollectionRealTimePriceApiV2Parameter["productPriceParameters"] =
        Object.keys(mlcData.availableAtOtherShipTos).map(shipToId => ({
            productId,
            unitOfMeasure,
            qtyOrdered,
            properties: {
                ShipToIdOverride: shipToId,
            },
        }));

    if (!productPriceParameters.length) {
        abort();
        return;
    }

    props.dispatch(
        loadRealTimePricing({
            productPriceParameters,
            onComplete: realTimePricingProps => {
                props.dispatch({
                    type: "Greif/Pages/ProductDetails/CompleteLoadMlcData",
                    productId,
                    multiLocationCatalogInfo: {
                        pricing: realTimePricingProps?.apiResult?.realTimePricingResults || [],
                        isMlcProduct: Boolean(mlcData.isMultiLocationCatalogProduct),
                        fullTruckLoads: tryJsonParse(props?.product?.properties?.fullTruckLoads) || [],
                        leadTimes: tryJsonParse(props?.product?.properties?.leadTimes) || [],
                        availableAtOtherShipTos: mlcData.availableAtOtherShipTos,
                    },
                });
            },
        }),
    );
});
